import { createBrowserRouter } from 'react-router-dom';
import { MerchantShell } from './components/MerchantShell';
import { ProtectedRoute } from './auth/ProtectedRoute';
import DashboardRoute from './routes/dashboard';
import SignupRoute from './routes/signup';
import PendingRoute from './routes/pending';
import WarehousesRoute from './routes/warehouses';
import StoresRoute from './routes/stores';
import StoreDetailRoute from './routes/store-detail';
import MembersRoute from './routes/members';
import CashiersRoute from './routes/cashiers';
import SettingsRoute from './routes/settings';

export const router = createBrowserRouter([
  { path: '/signup', element: <SignupRoute /> },
  { path: '/pending', element: <ProtectedRoute><PendingRoute /></ProtectedRoute> },
  {
    path: '/',
    element: <ProtectedRoute><MerchantShell><DashboardRoute /></MerchantShell></ProtectedRoute>,
  },
  {
    path: '/warehouses',
    element: <ProtectedRoute><MerchantShell><WarehousesRoute /></MerchantShell></ProtectedRoute>,
  },
  {
    path: '/stores',
    element: <ProtectedRoute><MerchantShell><StoresRoute /></MerchantShell></ProtectedRoute>,
  },
  {
    path: '/stores/:id',
    element: <ProtectedRoute><MerchantShell><StoreDetailRoute /></MerchantShell></ProtectedRoute>,
  },
  {
    path: '/members',
    element: <ProtectedRoute><MerchantShell><MembersRoute /></MerchantShell></ProtectedRoute>,
  },
  {
    path: '/cashiers',
    element: <ProtectedRoute><MerchantShell><CashiersRoute /></MerchantShell></ProtectedRoute>,
  },
  {
    path: '/settings',
    element: <ProtectedRoute><MerchantShell><SettingsRoute /></MerchantShell></ProtectedRoute>,
  },
]);
